import {call, put, select, takeLatest} from "redux-saga/effects";
import {storeAdvancedProbeTypes, storeSlaveList} from "../Actions/advanceTab.action";
import {
  requestAdvancedProbeTypesAsync,
  requestSlaveListAsync,
  updateSlaveAsync,
} from "../AsyncActions/advanceTab.async";
import {getSelectedController} from "../Selectors/controllers.selectors";
import * as actions from "../action.constants";

function* requestAdvancedProbeTypes() {
  try {
    const selectedController = yield select(getSelectedController);
    const response = yield call(requestAdvancedProbeTypesAsync, selectedController?.mac);
    if (response) {
      yield put(storeAdvancedProbeTypes(response?.data?.results));
    }
  } catch (e) {
    return e;
  }
}

function* requestSlaveList(action = {}) {
  const {probeId} = action;
  try {
    const selectedController = yield select(getSelectedController);
    const response = yield call(requestSlaveListAsync, {
      mac: selectedController?.mac,
      probeId,
    });
    if (response) {
      yield put(storeSlaveList(response?.data?.results));
    }
  } catch (e) {
    return e;
  }
}

function* updateSlave(action = {}) {
  const {probeId, payload = {}, callback = () => {}} = action;
  try {
    const selectedController = yield select(getSelectedController);
    const response = yield call(
      updateSlaveAsync,
      {
        mac: selectedController?.mac,
        probeId: probeId,
      },
      payload
    );
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* AdvanceTabSaga() {
  yield takeLatest(actions.REQUEST_ADVANCED_PROBE_TYPES, requestAdvancedProbeTypes);
  yield takeLatest(actions.REQUEST_SLAVE_LIST, requestSlaveList);
  yield takeLatest(actions.UPDATE_SLAVE, updateSlave);
}
